import React from 'react';
import { Link } from 'react-router-dom';
// import FacebookIcon from '../assets/facebook.svg';
// import LinkedinIcon from '../assets/linkedin.svg';
// import InstagramIcon from '../assets/instagram.svg';
import  { YoutubeFilled, FacebookFilled, InstagramFilled, LinkedinFilled, TwitterSquareFilled } from '@ant-design/icons'
// import { UserOutlined  } from '@ant-design/icons'
// import xIcon from '../assets/x-icon.svg';
import './features/features.css';



function Footer() {
    return (
        <React.Fragment>
            <div className="bg-black w-full h-auto md:h-auto lg:h-80 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 px-12 md:px-20 py-14">
                <div className="">
                    <h5 className="text-white font-semibold text-2xl">Customer Support</h5>
                    <p className="text-gray-400 text-md font-medium pr-5 mt-2">If you have any questions or want to know more about WayaQuick and our services, check our FAQ or contact our Customer Support</p>

                    <div className="btn-container mt-5 flex flex-col md:flex-row rounded">
                        <Link
                            to="/contact"
                            className="btn-register2 rounded-lg text-sm shadow"
                            // className="btn-register2 rounded-lg wqf-btn wqf-btn-primary wqc-submit"
                        >
                            CONTACT US
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="white" />
                            </svg>
                        </Link>

                        <div className="flex items-center justify-between gap-2 md:gap-8 mt-10 md:mt-0 lg:mt-0">
                            <a href="https://x.com/wayabank_ng" target="_blank" rel='noopener noreferrer'>
                                {/* <img src={xIcon} alt="x-icon" style={{width:'35px', height:'35px'}}/> */}
                                <TwitterSquareFilled
                                style={{ fontSize: '28px', color: '#c2410c' }}
                                 />
                            </a>
                            <a href="https://web.facebook.com/wayaquickng/?mibextid=LQQJ4d&_rdc=1&_rdr" target="_blank" rel='noopener noreferrer' >
                                {/* <img src={FacebookIcon} alt="facebook" /> */}
                                <FacebookFilled
                                style={{ fontSize: '28px', color: '#c2410c' }}
                                 />
                            </a>
                            <a href="https://www.instagram.com/p/DHF5Vkfou_c/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==" target="_blank" rel='noopener noreferrer'>
                                {/* <img src={InstagramIcon} alt="instagram" /> */}
                                <InstagramFilled
                                style={{ fontSize: '28px', color: '#c2410c' }}
                                 />
                            </a>
                            <a href="https://www.linkedin.com/company/wayabank/posts/?feedView=all" target="_blank" rel='noopener noreferrer'>
                                {/* <img src={LinkedinIcon} alt="linkedin" /> */}
                                <LinkedinFilled
                                style={{ fontSize: '28px', color: '#c2410c' }}
                                 />
                            </a>
                            <a href="https://www.youtube.com/channel/UCWiRevjFvR6vI9E3Eh9Npxg" target="_blank" rel='noopener noreferrer'>
                                <YoutubeFilled
                                style={{ fontSize: '40px', color: '#c2410c' }}
                                 />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="md:pl-0 lg:pl-24 md:block lg:block h-auto">
                    <p className="text-gray-400 text-md font-medium pr-5 mt-10">Be the First to Know About our Promotions, Giveaways, and Amazing Business Offers</p>
                    <div className="relative flex mt-6 flex-col lg:flex-row lg:items-center">
                        <input type="email" placeholder="Enter your email address" className="w-full pl-4 py-2 rounded-tr-0 rounded-br-0 border border-white bg-transparent text-white" />
                        <button className="bg-white font-medium text-primary-theme px-3 py-3 mt-4 lg:mt-0 flex items-center justify-center text-white rounded-bl-0 rounded-tl-0 text-sm shadow">
                            SUBSCRIBE
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" fill="white" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <div className="px-8 md:px-20 mt-10 h-auto">
                <hr />
            </div>
            <div className="px-8 h-auto md:px-20 mt-8 mb-16 md:mb-4 py-4 flex flex-col gap-2 items-center justify-between">
                
                <p className="flex gap-6 flex-wrap">
                    <a href="https://www.wayalinks.com/about-us" target="_blank" rel='noreferrer' className="text-primary-theme font-semibold text-sm">About Us</a>
                    <Link to="/contact" className="text-primary-theme font-semibold text-sm">Contact</Link>
                    <Link to="/sdks" className="text-primary-theme font-semibold text-sm">Plugins & SDKs</Link>
                    {/* <Link to="/#FAQs" className="text-primary-theme font-semibold text-sm">FAQs</Link> */}
                    <Link to="/compliance" className="text-primary-theme font-semibold text-sm">compliance</Link>
                    <Link to="/pricing" className="text-primary-theme font-semibold text-sm">pricing</Link>
                    <Link to="/product-fraud" className="text-primary-theme font-semibold text-sm">Security</Link>
                    <a href="/privacy" target="_blank" className="text-primary-theme font-semibold text-sm">Privacy Policy</a>
                    <a href="/cookies" target="_blank" className="text-primary-theme font-semibold text-sm">Cookies Policy</a>
                    <a href="/terms" target="_blank" className="text-primary-theme font-semibold text-sm">Terms & Conditions</a>
                    {/* <a href="https://wayabank.zohodesk.com/portal/en/home" target="_blank" rel='noreferrer' className="wq-support-btn wq-support-help">
                        <UserOutlined />
                        <span className="wq-support-label">Support</span>
                    </a> */}
                </p>
                <p>Copyright © Waya {new Date().getFullYear()}  All rights reserved</p>
            </div>
        </React.Fragment>
    )
}

export default Footer